import { render, staticRenderFns } from "./register.vue?vue&type=template&id=006f7b36&scoped=true"
import script from "./register.vue?vue&type=script&lang=js"
export * from "./register.vue?vue&type=script&lang=js"
import style0 from "./register.vue?vue&type=style&index=0&id=006f7b36&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006f7b36",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\iotcarduserui\\iotcardpc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('006f7b36')) {
      api.createRecord('006f7b36', component.options)
    } else {
      api.reload('006f7b36', component.options)
    }
    module.hot.accept("./register.vue?vue&type=template&id=006f7b36&scoped=true", function () {
      api.rerender('006f7b36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/register/register.vue"
export default component.exports